export const autoFocusElement = (selector: string, delay = 450) => {
  setTimeout(() => {
    const input: HTMLElement | null = document.querySelector(selector);
    if (!input) return;
    input.focus();
  }, delay);
};
